<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'

	export type NeedToKnowProps = {
		title?: string
		description?: string
		icon: {
			dir?: string
			name?: string
			pathClass?: string
			class?: string
		}
		titleClass?: ClassNameValue
		descClass?: ClassContext
		wrapperClass?: ClassContext
	}[]

	defineProps<{
		needToKnow: NeedToKnowProps
	}>()
</script>

<template>
	<div class="">
		<ul class="flex min-h-[272px] w-full flex-col space-y-7 rounded-md border md:p-[32px_24px_32px_24px]">
			<li
				v-for="item in needToKnow"
				:key="item.description"
				class="flex items-center gap-3"
				:class="item.wrapperClass"
			>
				<div
					:class="item.icon.class"
					class="flex h-[40px] w-[40px] flex-none items-center justify-center rounded-full"
				>
					<lazy-tools-icon
						:icon="item.icon?.name || ''"
						:dir="item.icon?.dir || ''"
						:height="18"
						:width="18"
						:path-class="item.icon.pathClass"
					/>
				</div>
				<div class="space">
					<h5
						v-if="item?.title"
						:class="cn('text-base font-semibold leading-6 text-[#094063]', item.titleClass)"
					>
						{{ item.title }}
					</h5>
					<p
						:class="cn('text-sm font-medium leading-normal tracking-wide', item.descClass)"
						v-html="item.description"
					/>
				</div>
			</li>
		</ul>
		<slot />
	</div>
</template>
